import React from "react";
import { Label } from "@/components/ui/label";
import UnitSelect from "@/components/unit-select";
import InlineEditableTextarea from "@/components/InlineEditableTextarea";

interface MeasurementFieldsValue {
  measurement_default_unit?: string | null;
  measurement_instructions?: string | null;
}

interface MeasurementFieldsEditorProps {
  value: MeasurementFieldsValue;
  onChange: (value: MeasurementFieldsValue) => void;
}

export function MeasurementFieldsEditor({
  value,
  onChange,
}: MeasurementFieldsEditorProps) {
  return (
    <div className="space-y-3">
      <div className="space-y-1">
        <Label className="text-xs font-medium">Default Unit</Label>
        <UnitSelect
          value={(value.measurement_default_unit as string) || ""}
          onChange={(next) =>
            onChange({
              ...value,
              measurement_default_unit: next,
            })
          }
          placeholder="Select unit..."
        />
      </div>

      <div className="space-y-1">
        <Label className="text-xs font-medium">Instructions</Label>
        <InlineEditableTextarea
          value={(value.measurement_instructions as string) || ""}
          onSave={(next) =>
            onChange({
              ...value,
              measurement_instructions: next,
            })
          }
          placeholder="Enter measurement instructions..."
          textareaClassName="h-16 text-xs resize-none"
        />
      </div>
    </div>
  );
}
